<template>
    <modal-privacy-policy-agreement v-if="isActiveModal"
                                    :privacy-policy-statuses="privacyPolicyStatuses"
                                    @close="isActiveModal = false"
                                    data-jest="wrapper-modal-privacy-policy-agreement"
    />
</template>

<script>
import ModalPrivacyPolicyAgreement from "./ModalPrivacyPolicyAgreement.vue";
import * as privacyPolicyAgreementAction from "../../model/action/PrivacyPolicyAgreementAction.js"
import {mapActions, mapGetters} from "vuex";
import UserAgentUtil from "../../util/UserAgentUtil.js";

export default {
    name: "WrapperModalPrivacyPolicyAgreement",
    components: {ModalPrivacyPolicyAgreement},
    data() {
        return {
            privacyPolicyStatuses: null,
            isActiveModal: false,
            hasFetched: false,
        }
    },
    mounted() {
        this.getIsAppli(this.isAppliUa)
        this.fetchIfLoggedIn()
    },
    computed: {
        ...mapGetters({
            isAppli: 'AccountStoreV2/isAppli',
            accountStatus: 'AccountStoreV2/accountStatus',
        }),
        isLoggedIn() {
            return !!(this.accountStatus && this.accountStatus.account)
        },
        isAppliUa() {
            return new UserAgentUtil().isAppli
        },
    },
    watch: {
        isLoggedIn(newVal) {
            if (newVal) {
                this.fetchIfLoggedIn()
            }
        }
    },
    methods: {
        ...mapActions({
            getIsAppli: 'AccountStoreV2/getIsAppli'
        }),
        fetchIfLoggedIn() {
            if (this.isLoggedIn && !this.isAppli && !this.hasFetched) {
                this.hasFetched = true
                this.getPrivacyPolicyStatuses()
            }
        },
        /**
         * APIによりDBに管理されている同意取得状況を取得する
         * サーバサイドでcookieまで考慮して判定しているので、フロント側ではcookie考慮しなくて良い
         */
        getPrivacyPolicyStatuses() {
            privacyPolicyAgreementAction.getPrivacyPolicyStatuses()
                .then(result => {
                    this.privacyPolicyStatuses = result
                    // APIで同意していないポリシーがあればモーダル表示
                    // （policyStatusがnullの場合は同意が必要なポリシー無し＝全て同意済みとして判定する）
                    const needAgreePolicies = [result.servicePolicy, result.specialContract].map(policyStatus => policyStatus ? policyStatus.agreed : true).includes(false)
                    //アプリでは起動時に同意取得が入るので、モーダルは表示不要
                    this.isActiveModal = needAgreePolicies && !this.isAppli
                })
                .catch(error => {
                    // 失敗した場合はモーダル表示
                    this.isActiveModal = true
                });
        },
    }
}
</script>
